// 有线电视缴费——微信，主流程
const wxMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `television/wx/index${i + 1}`,
  name: `televisionWxIndex${i + 1}`,
  component: () => import(`@/views/life/television/wx/index${i + 1}.vue`)
}))

// 有线电视缴费——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `television/zfb/index${i + 1}`,
  name: `televisionZfbIndex${i + 1}`,
  component: () => import(`@/views/life/television/zfb/index${i + 1}.vue`),
}));

export default {
  path: '/life',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 有线电视缴费——微信，开始
    ...wxMainRoutes,

    // 有线电视缴费——支付宝，主流程
    ...zfbMainRoutes,
  ]
}
